// action type
export const EXPORT_FILE = 'EXPORT_FILE';
export const GET_EXPORT_FILE = 'GET_EXPORT_FILE';
export const SET_EXPORT_STATUS = 'SET_EXPORT_STATUS';
export const SET_EXPORT_ID = 'SET_EXPORT_ID';

// status
export const EXPORT_STATUS_PENDING = 'PENDING';
export const EXPORT_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const EXPORT_STATUS_SUCCESS = 'SUCCESS';
export const EXPORT_STATUS_FAILURE = 'FAILURE';
export const EXPORT_STATUS_DONE = 'DONE';

// pusher
export const EXPORT_PUSHER_CHANNEL = (businessId, featureName) =>
  `export-${businessId}-${featureName}`;
export const EXPORT_PUSHER_EVENT = 'export';

// feature name
export const ORDER_EXPORT_TRANSACTION = 'order-export-transaction';
export const ORDER_EXPORT_ITEM_DETAIL = 'order-export-item-detail';

export const SUPPLIER_EXPORT = 'supplier-export-worker-app-gsh';
export const ORDER_EXPORT_INVOICE_TRANSACTION =
  'order-export-invoice-transaction';
export const ORDER_EXPORT_INVOICE_ITEM_DETAIL =
  'order-export-invoice-item-detail';

// modal
export const EXPORTING_SHOW_EXPORT_MODAL = `EXPORTING_SHOW_EXPORT_MODAL`;
export const EXPORTING_HIDE_EXPORT_MODAL = `EXPORTING_HIDE_EXPORT_MODAL`;
